import React from 'react'
import { socialData } from '../DataFiles/socialData'
import './social.css'
const Social = () => {
    return (
        <div>
            <div className="socialMedia socialMedia2">
                {socialData.map((s) => (
                    <span className='icon' key={s.link}>
                        <a href={s.link}
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <i className={s.icon}></i>
                        </a>
                    </span>
                ))}
            </div>
        </div>
    )
}

export default Social